import { FilledButton } from '../util/button';

interface ReserveButtonFieldProps {
  disable: boolean;
  onClick: () => void;
}
export const ReserveButtonField = ({
  disable,
  onClick,
}: ReserveButtonFieldProps) => {
  return (
    <div className={'next-button-field'}>
      <FilledButton
        onClick={onClick}
        label={'入庫予約をする'}
        disabled={disable}
      />
    </div>
  );
};
